import { type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 font-medium whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-daydra-raised text-daydra-dim border border-daydra-border",
        accent: "bg-daydra-accent-dim text-daydra-accent border border-daydra-accent/20",
        success: "bg-daydra-success-dim text-daydra-success border border-daydra-success/20",
        error: "bg-daydra-error-dim text-daydra-error border border-daydra-error/20",
        warning: "bg-daydra-warning-dim text-daydra-warning border border-daydra-warning/20",
        info: "bg-daydra-info-dim text-daydra-info border border-daydra-info/20",
        ghost: "bg-transparent text-daydra-muted border border-transparent",
      },
      size: {
        sm: "text-2xs px-1.5 py-0.5 rounded-md",
        default: "text-xs px-2 py-0.5 rounded-md",
        lg: "text-sm px-2.5 py-1 rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <span
      className={cn(badgeVariants({ variant, size, className }))}
      {...props}
    />
  );
}
